<template>
  <div class="container mx-auto px-4">
    <div class="sm:px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.class')}}</Header>

      <Classe
        v-for="classe in classi.items"
        v-bind:classe="classe"
        :key="classe.id"
      ></Classe>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  beforeMount() {
    const self = this;
    this.getClassi()
      .then(() => {
        if (
          self.$store.state.classi.all.items &&
          self.$store.state.classi.all.items.length === 1
        ) {
          const classe = self.$store.state.classi.all.items[0];
          this.setSelectedClass(classe);
        }
      });
  },
  methods: {
    ...mapActions('classi', ['setSelectedClass', 'getClassi']),
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    classi() {
      return this.$store.state.classi.all;
    },
  },
};
</script>
